import React, { useState, useEffect } from 'react'
import Modal                          from '@react/shared/ui/Modal'

const CHOICES = ['follow_workflow', 'not_applicable']

const DraftRecordsModal = ({ count, objectType, saving, onCancel, onConfirm }) => {
  const [choice, setChoice] = useState(CHOICES[0])

  useEffect(() => { if (count) setChoice(CHOICES[0]) }, [count])

  return (
    <Modal
      isOpen  = {count > 0}
      onClose = {onCancel}
      size    = 'md'
      title   = {I18n.t('validation_workflows.draft_records.title')}
      footer  = {
        <div className='flex justify-end gap-[5px] w-full'>
          <div className='btn btn-sm btn-default' onClick={onCancel}>
            {I18n.t('button.cancel')}
          </div>
          <div
            className = {`btn btn-sm btn-primary ${saving ? 'disabled' : ''}`}
            onClick   = {() => { if (!saving) onConfirm(choice) }}
          >
            {I18n.t('button.save')}
          </div>
        </div>
      }
    >
      <div className='flex items-center gap-3'>
        <span className='bg-gray-100 text-gray-900 font-semibold px-3 py-0.5 rounded-xl'>{count}</span>
        <span className='text-gray-900'>
          {I18n.t(`validation_workflows.draft_records.records.${objectType}`, { count })}
        </span>
      </div>

      <p className='text-gray-600 mb-0'>{I18n.t('validation_workflows.draft_records.explanation')}</p>

      <div className='flex flex-col gap-2'>
        {CHOICES.map(value => (
          <label
            key       = {value}
            className = {`flex items-start gap-3 m-0 border rounded-md px-4 py-3 cursor-pointer font-normal ${
              choice === value ? 'border-indigo-300 bg-indigo-50' : 'border-gray-200'
            }`}
          >
            <input
              type      = 'radio'
              name      = 'draft_records'
              className = 'mt-1'
              checked   = {choice === value}
              onChange  = {() => setChoice(value)}
            />
            <span>
              <span className='block font-semibold text-gray-900'>
                {I18n.t(`validation_workflows.draft_records.choices.${value}.title`)}
              </span>
              <span className='block text-xs text-gray-500 mt-1'>
                {I18n.t(`validation_workflows.draft_records.choices.${value}.hint`)}
              </span>
            </span>
          </label>
        ))}
      </div>
    </Modal>
  )
}

export default DraftRecordsModal
